import { render, staticRenderFns } from "./CloseAmortizationDetail.vue?vue&type=template&id=4b971e6c&"
import script from "./CloseAmortizationDetail.vue?vue&type=script&lang=ts&"
export * from "./CloseAmortizationDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b971e6c')) {
      api.createRecord('4b971e6c', component.options)
    } else {
      api.reload('4b971e6c', component.options)
    }
    module.hot.accept("./CloseAmortizationDetail.vue?vue&type=template&id=4b971e6c&", function () {
      api.rerender('4b971e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/amortization/CloseAmortizationDetail.vue"
export default component.exports